/**
 * Workflows are called Automations in the app: `/workflows[/id][?…]` lands
 * on `/automations[/id][?…]`, so old links, bookmarks and recent items keep
 * working.
 */
import { Navigate, useLocation, useParams } from 'react-router-dom';

export function WorkflowsRedirect() {
  const { id } = useParams();
  const { search } = useLocation();
  return <Navigate to={`/automations${id ? `/${encodeURIComponent(id)}` : ''}${search}`} replace />;
}
